<template>
    <div class="ut-relative">
        <div class="search-input input" :class="{'showicon': this.showIcon == true}">
            <input v-on:keyup="SuburbSearch"
                class="ga-event"
                :data-category="gacategory" :data-eventlabel="gatext" 
                :data-eventvaluetype="gavaluetype" :data-eventvalue="gavalue"
                v-model="searchTerm"
                ref="suburbInput"
                type="text" value=""
                :placeholder="this.placeholder" />
        </div>
        <search-results
            :results="searchResults"
            :searchType="searchType"
            @selectedResult="updateSelectedAddress"></search-results>
    </div>
</template>

<script>
import axios from 'axios';
import SearchResults from '@/components/forms/search/searchResults/SearchResults.vue';

const geocoder = new google.maps.Geocoder();

export default {
  name: 'SuburbSearch',
  components: {
    SearchResults,
  },
  props: {
    existingAddress: {
      required: false,
      default: null,
    },
    placeholderText: null,
    showIcon: null,
    gacategory: null,
    gatext: null,
    gavaluetype: null,
    gavalue: null,
  },
  data() {
    return {
      searchTerm: this.existingAddress,
      searchResults: [],
      searchType: 'suburb',
      selectedResult: null,
      placeholder: null,
    };
  },
  created() {
    this.placeholder = this.placeholderText;
  },
  mounted() {

  },
  methods: {
    SuburbSearch() {
      if (this.searchTerm.length >= 2) {
        axios.get(`${process.env.VUE_APP_API_URL}/PostcodeREST/find/${this.searchTerm}`)
          .then((response) => {
            this.searchResults = response.data.data;

            if (this.searchResults.length === 0) {
            }
          })
          .catch((error) => {
            this.searchResults = [];
          });
      } else {
        this.hideResults();
      }
    },
    googleSearch() {
      geocoder.geocode({ address: this.searchTerm, region: 'AU' }, (results, status) => {
        if (status == 'OK' && results && results.length > 0) {
          function parseGeocode(geocode) {
            const r = geocode.formatted_address;
            const pos = geocode.geometry.location;

            try {
              return {
                latitude: pos.lat,
                longitude: pos.lng,
                streetaddress: r.split(',')[0],
                suburb: r.split(',')[1].match(/[A-Z][^A-Z0-9\s]+\s?/g).join('').replace(/\s+$/, ''),
                state: r.split(',')[1].match(/\b[A-Z]+\b/)[0],
                postcode: r.split(',')[1].match(/\d{4}/)[0],
                geolocationtype: geocode.geometry.location_type,
              };
            } catch (err) {
              console.error(`Error while parsing address ${r}`);
              return null;
            }
          }

          const filterSearchResults = this.filterGeocode(results, true)
            .map((x) => {
              // console.log(x);
              const r = x.formatted_address.split(',').slice(0, 2).join('');
              return {
                id: null,
                address: r,
                details: parseGeocode(x),
              };
            }).filter(x => !!x);


          this.searchResults = filterSearchResults;
        } else {
          this.searchResults = [];
        }
      });
    },
    filterGeocode(results, filterForRealAddresses) {
      // remove results that aren't an Australian address
      return results.filter((x) => {
        var is_address = true;
        if (filterForRealAddresses) {
          var is_address = x.address_components
            .filter(y => y.types.indexOf('street_number') != -1)
            .length > 0;
        }
        const is_aus = !!x.formatted_address.match(/Australia/);
        return is_aus && is_address;
      });
    },
    getCLPropertyDetails(id) {
      return axios.get(`${process.env.VUE_APP_CLAPI_URL}/v1/property/details?id=${id}`)
        .then((response) => {
          if (response.data.success) {
            return response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    hideResults() {
      this.searchResults = [];
    },
    updateSelectedAddress(selected) {
      this.searchTerm = `${selected.suburb}, ${selected.state}, ${selected.postcode}`;
      this.selectedResult = selected.id;
      this.placeholder = '';

      // we have a CL property
      if (selected.id != null) {
        selected.source = 'cl';

        this.hideResults();

        this.getCLPropertyDetails(selected.id).then((res) => {
          // console.log(res);

          selected.details = res;
          this.$emit('selectedResult', selected);
          this.hideResults();
        });
      }
      // We have a google property
      else {
        selected.id = null;
        selected.source = 'google';

        this.$emit('selectedResult', selected);
        this.hideResults();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
    .search-input {
        input {
            width: 100%;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            width: -moz-available;
            width: -webkit-fill-available;
            width: stretch;
            border-radius: 4px;
            border: 1px solid #E5E4E4;
            padding: 14px;
            outline: none;
        }

        .selected-suburb{
            @apply ut-inline-block ut-px-2 ut-mr-2 ut-py-1 ut-my-1;
            color: rgba(44,62,80,0.7);
            font-size: 14px;
            background-color: rgba(225,225,225,0.8);
            border-radius: 3px;
            letter-spacing: 0.3px;
            line-height: 22px;

            img {
                @apply ut-cursor-pointer ut-inline-block ut-ml-2;
            }
        }

    }

</style>
